import { Navigate, Route, Routes } from "react-router-dom";
import CompatiblePage from "./pages/CompatiblePage";
import KakaoLoginPage from "./pages/KakaoRedirectPage";
import LoginPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import MyPage from "./pages/MyPage";
import AppMainPage from "./pages/app/MainPage";
import AppCompatiblePage from "./pages/app/CompatiblePage";
import AppLoginPage from "./pages/app/LoginPage";
import AppMyPage from "./pages/app/MyPage";
import AppKakaoLoginPage from "./pages/app/KakaoRedirectPage";
import AppNaverRedirectPage from "./pages/app/NaverRedirectPage";
import PrivacyPage from "./pages/PrivacyPage";
import UseTermPage from "./pages/UseTermPage";
// import Footer from "./components/Footer";
import PaymentPage from "./pages/payment";
import PaymentCompletePage from "./pages/payment/PaymentCompletePage";
import PaymentUseTermPage from "./pages/payment/terms/UseTermPage";
import PaymentPrivacyTermPage from "./pages/payment/terms/PrivacyTermPage";
import PaymentAgreementPage from "./pages/payment/terms/PaymentAgreementPage";
// import { useEffect } from "react";
// import { getSaju } from "./framework/api";

function App() {
  // useEffect(() => {
  //   const updateVisitDay = () => {
  //     const storedVisitDay = localStorage.getItem("visitDay");
  //     const today = new Date();
  //     const todayDateStr = today.toISOString().split("T")[0];

  //     if (storedVisitDay) {
  //       const storedDateStr = new Date(storedVisitDay)
  //         .toISOString()
  //         .split("T")[0];

  //       if (storedDateStr < todayDateStr) {
  //         localStorage.setItem("visitDay", todayDateStr);
  //         console.log("today you visit this page first");
  //         // API 호출
  //         getSaju.post("/mobile/visit").catch((error) => console.log(error));
  //       } else {
  //         console.log("today you visit this page before");
  //       }
  //     } else {
  //       localStorage.setItem("visitDay", todayDateStr);
  //       console.log("today you visit this page first");
  //       getSaju.post("/mobile/visit").catch((error) => console.log(error));
  //     }
  //   };

  //   updateVisitDay();
  // }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/compatible" element={<CompatiblePage />} />
          <Route path="/MyPage" element={<MyPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/kakao/redirect" element={<KakaoLoginPage />} />
          <Route path="/terms/privacy_policy" element={<PrivacyPage />} />
          <Route path="/terms/use" element={<UseTermPage />} />
          <Route path="/terms/pay/use" element={<PaymentUseTermPage />} />
          <Route
            path="/terms/pay/privacy"
            element={<PaymentPrivacyTermPage />}
          />
          <Route
            path="/terms/pay/agreement"
            element={<PaymentAgreementPage />}
          />
          <Route path="/payment/complete" element={<PaymentCompletePage />} />

          {/* 앱 패키징용 페이지 */}
          <Route path="/app" element={<AppMainPage />} />
          <Route path="/app/compatible" element={<AppCompatiblePage />} />
          <Route path="/app/MyPage" element={<AppMyPage />} />
          <Route path="/app/login" element={<AppLoginPage />} />
          <Route
            path="/app/login/kakao/redirect"
            element={<AppKakaoLoginPage />}
          />
          <Route
            path="/app/login/naver/redirect"
            element={<AppNaverRedirectPage />}
          />
          {/* <Route path="/login/naver/redirect" element={<NaverLoginPage />} /> */}
          <Route path="/payment/*" element={<PaymentPage />} />
          <Route path={"*"} element={<Navigate to="/" />} />
        </Routes>
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
